import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/grapes'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'grapes'

export const metadata = {
  icon: 'pagelines',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const GrapesListPage = createListPage({ metadata, api, actionCreators, Content })
const GrapesDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { GrapesListPage, GrapesDetailPage }
